"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InterestPaymentsHeaderFormContainer = _interopRequireDefault(require("./InterestPaymentsHeaderFormContainer"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity');
var InterestPaymentsHeaderWithFilterComponent = function InterestPaymentsHeaderWithFilterComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("interest"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('header-bar')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('header-text')
  }, t("Interest Payments")), props.children), /*#__PURE__*/_react["default"].createElement(_InterestPaymentsHeaderFormContainer["default"], null));
};
var _default = exports["default"] = InterestPaymentsHeaderWithFilterComponent;